import gql from 'graphql-tag';

const GET_MAIL_REPORT = gql`
    query getMailReport {
        getMailReport {
            jobName
            createdAt
            updatedAt
            emails
            enabled
            nameReport
        }
    }
`;

export default GET_MAIL_REPORT;